import $ from 'jquery'

import { Organigramma } from './organigramma'

// auto-init on enhance (which is called on domready)

$.fn['organigramma'] = function() {
	return this.each( function() {
		new Organigramma( this ).init()
	} )
}

$( document ).bind( 'enhance', function( e ) {
	$('.organigramma-lev1', e.target)['organigramma']()
} )
/*
$( document ).ready( () => {
	$( document ).on( 'click', '.Organigramma a, .Organigramma--accordion a', function( a ) {
	    if ( '#' === $( this ).attr( 'href' ) || '' === $( this ).attr( 'href' ) ) a.preventDefault(), a.stopPropagation()
	} )
} )
*/
export default { Organigramma }



// WEBPACK FOOTER //
// ./src/components/organigramma/index.js